export const CREATE_ARCHIVE = 'CREATE_ARCHIVE'
export const SAVED_ARCHIVE = 'SAVED_ARCHIVE'
export const SAVED_ARCHIVE_RES = 'SAVED_ARCHIVE_RES'
export const EDIT_ARCHIVE = 'EDIT_ARCHIVE'
export const FETCH_ARCHIVE = 'FETCH_ARCHIVE'
export const FETCHED_ARCHIVE = 'FETCHED_ARCHIVE'
export const DELETE_ARCHIVE = 'DELETE_ARCHIVE'
export const DELETED_ARCHIVE = 'DELETED_ARCHIVE'
export const NOTIFICATION_DONE_ARCHIVE = 'NOTIFICATION_DONE_ARCHIVE'

export const FETCH_DOWNLOAD_ARCHIVE = 'FETCH_DOWNLOAD_ARCHIVE'
export const FETCHED_DOWNLOAD_ARCHIVE = 'FETCHED_DOWNLOAD_ARCHIVE'

